<template>
  <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center justify-content-between mb-4">
        <h4><i class="fas fa-history"></i> Histórico de Endereços</h4>
        <div>
          <button
            class="btn active btn-outline-secondary btn-sm"
            title="Voltar para Identificação da Família e Endereço"
            @click="$emit('voltar')"
          >
            <i class="mdi mdi-arrow-left"></i>Voltar
          </button>
        </div>
      </div>
    </div>
    <loading-animation
      :active.sync="loading"
      :is-full-page="false"
      :opacity="1"
      color="#5895FF"
    />
    <div class="col-md-6 mb-3" v-for="endereco in enderecos" :key="endereco.id">
      <div class="card border">
        <div class="card-header bg-gray">
          <p>Data: {{ endereco.created_at || formatDate }}</p>
          <p>Técnico: {{ endereco.user_id }}</p>
        </div>
        <div class="card-body">
          <p v-if="endereco.localidade">
            Localidade:
            <strong>{{ endereco.localidade.nome_localidade }}</strong>
          </p>
          <p v-if="endereco.logradouro">
            Logradouro:<strong>
              {{ endereco.logradouro.tipo_logradouro }}:
              {{ endereco.logradouro.titulo_logradouro }}
              {{ endereco.logradouro.nome_logradouro }}
            </strong>
          </p>
          <p>
            Número: <strong>{{ endereco.numero_endereco }}</strong>
          </p>
          <p>
            Cep: <strong>{{ endereco.logradouro.cep }}</strong>
          </p>
          <p>
            Complemento: <strong>{{ endereco.complemento_endereco }}</strong>
          </p>
          <p>
            Referência: <strong>{{ endereco.referencia_endereco }}</strong>
          </p>
          <p>
            Acolhimento Institucional:
            <strong v-if="endereco.abrigo == 1">SIM</strong>
            <strong v-else>NÃO</strong>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Read",
  props: ["familiaId"],
  data() {
    return {
      loading: true,
      enderecos: {},
    };
  },
  mounted() {
    this.getEnderecos();
  },
  methods: {
    getEnderecos() {
      axios
        .get("api/dashboard/familias/historico/enderecos/" + this.familiaId)
        .then((response) => {
          this.enderecos = response.data.data;
          this.loading = false;
        })
        .catch(() => {
          this.$router.push(
            "/dashboard/familias/edit/" + this.familiaId + "/identificacao"
          );
        });
    },
  },
};
</script>
